module.exports = __webpack_public_path__ + "files/a28815214409f3c537c36f3127334c77.svg";